var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#64AC4E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.226 7.793v.711a7.727 7.727 0 11-4.582-7.062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#64AC4E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.226 2.322L8.5 10.056 6.181 7.74"
  })));
}

export default __webpack_public_path__ + "./fonts/check-circle.182a69b2cf31ae92e3af3a6d17cd32d8.svg";
export { SvgCheckCircle as ReactComponent };